<template>
    <div class="report-thumbnail m-auto">
        <UpgradeReportAlert v-if="showUpgradeAlert" @open-payment="$emit('open-payment')" class="max-w-xl mx-auto" />
        <div v-if="page == 'my-quiz'" class="select-quiz-thumbnail">
            <XSelect
                @input="
                    val => {
                        onInput({ target: { value: val } })
                    }
                "
                :options="quizLists.map(quiz => ({ id: quiz._id.$oid, label: quiz.title }))"
                :placeholder="$t('report_thumbnail_select_quiz')"
                label="label"
                class="input input-block input-text-center quiz-dropdown system-border"
                style="padding: 5px; border-radius: 50px"
                name="quizList"
                id="report-select-quiz"
                dense
                outlined
            ></XSelect>
        </div>

        <div class="max-w-xl m-auto">
            <div
                v-if="isQuizListLoaded"
                class="mb-6 pt-6 system-text-color system-text-shadow font-bold font-size-16 md:font-size-20 font-opensans flex flex-col md:flex-row items-center"
            >
                <div class="flex-1">
                    <span>{{ $t('my_quiz_tab_report') }}</span>
                    <span class="mx-2">•</span>
                    <span>
                        <a
                            @click.prevent="onFilterWithType('all')"
                            :class="{
                                'font-normal system-text-color  no-underline hover:underline': true,
                                'system-primary-text-color font-bold': filterType == 'all'
                            }"
                            href="#"
                            >{{ $t('report_thumbnail_all_tab') }}</a
                        >
                    </span>
                    <span class="font-normal px-1">|</span>
                    <span>
                        <a
                            @click.prevent="onFilterWithType('mine')"
                            :class="{
                                'font-normal system-text-color  no-underline hover:underline': true,
                                'system-primary-text-color font-bold': filterType == 'mine'
                            }"
                            href="#"
                            >{{ $t('report_thumbnail_mine_tab') }}</a
                        >
                    </span>
                    <span class="font-normal px-1">|</span>
                    <span>
                        <a
                            @click.prevent="onFilterWithType('shared')"
                            :class="{
                                'font-normal system-text-color  no-underline hover:underline': true,
                                'system-primary-text-color font-bold': filterType == 'shared'
                            }"
                            href="#"
                            >{{ $t('report_thumbnail_shared_tab') }}</a
                        >
                    </span>
                </div>
                <span @click="openMergeReportModal" class="cursor-pointer font-normal hover:underline mt-4 md:mt-0">
                    <i class="far fa-copy"></i>
                    {{ $t('merge_report_header') }}
                </span>
            </div>

            <div
                v-if="!quizReportLists.length"
                class="flex flex-col justify-center items-center max-w-xl mx-auto my-12"
            >
                <i class="fas fa-scroll system-text-color system-text-shadow font-size-40 md:font-size-56"></i>
                <h4 class="system-text-color system-text-shadow text-center md:font-size-18 m-0 my-4">
                    {{ $t('my_quiz_no_report_quiz') }}
                </h4>
            </div>

            <div
                v-for="(report, index) in quizReportLists"
                :key="index"
                class="report-download-modal text-dark-charcoal system-border bg-white report-row p-4 mb-2"
            >
                <div class="flex justify-start items-center w-full lg:w-full">
                    <div class="report-name-container">
                        <strong
                            v-tippy="{ placement: 'top' }"
                            :content="report.name || `[${$t('report_live_play')}]`"
                            class="truncate block font-size-16"
                        >
                            {{ report.name || `[${$t('report_live_play')}]` }}
                        </strong>
                        <div
                            v-tippy="{ placement: 'top' }"
                            :content="setTitleQuiz(report.quiz)"
                            class="truncate font-size-14 shadow-text-none"
                        >
                            {{ setTitleQuiz(report.quiz) }}
                        </div>
                        <div v-if="report.user" class="flex items-center mt-1 opacity-75">
                            <span class="text-xs block">
                                {{ $t('report_thumbnail_report_creator') }}:
                                {{ report.user.name }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="flex justify-start items-center w-full md:w-1/2 lg:w-2/3">
                    <div class="mr-2 py-2">
                        <i class="far fa-calendar shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <span
                            v-tippy="{ placement: 'top' }"
                            :content="$t('report_thumbnail_latest_save_on', { datetime: report.latest_result_at })"
                            class="font-size-14 shadow-text-none"
                        >
                            {{ report.latest_result_at.split(' ')[0] }}
                        </span>
                    </div>
                </div>
                <div class="flex justify-start items-center w-full md:w-1/2 lg:w-1/2">
                    <div class="mr-2 py-2">
                        <i class="far fa-user shadow-text-none font-size-22"></i>
                    </div>
                    <div v-tippy="{ placement: 'top' }" :content="$t('report_number_of_player')">
                        <a
                            @click.prevent="listPlayerInReport(report)"
                            href="#"
                            class="font-size-14 shadow-text-none text-dark-charcoal no-underline hover:underline"
                        >
                            {{
                                !report.result_data.length && report.result_data.users
                                    ? report.result_data.users.length
                                    : 'N/A'
                            }}{{ report.limit_player ? `/${report.limit_player}` : '' }}
                        </a>
                    </div>
                </div>

                <div class="flex justify-start items-center w-full md:w-1/2 lg:w-1/2">
                    <div class="mr-2 py-2">
                        <i class="far fa-play-circle shadow-text-none font-size-24"></i>
                    </div>
                    <div v-tippy="{ placement: 'top' }" :content="$t('report_played_as')">
                        <span class="font-size-14 shadow-text-none">
                            {{
                                report.playing_type
                                    ? report.playing_type == 'live'
                                        ? $t('report_played_live')
                                        : $t('report_played_playalone')
                                    : $t('report_played_live')
                            }}
                        </span>
                    </div>
                </div>

                <div v-if="report.is_owner" class="flex lg:justify-center items-center w-full md:w-1/2 lg:w-full">
                    <!-- Begin toggle lock -->
                    <div
                        v-tippy="{ placement: 'top' }"
                        v-if="!report.is_updating_report"
                        @click="onUpdateLockReport(report)"
                        :class="[
                            'mr-2 py-2 cursor-pointer',
                            !report.is_shared_as_public && !report.is_quiz_owner ? 'opacity-50 pointer-events-none' : ''
                        ]"
                        :content="$t('report_sharing_toggle_lock_save_to_report')"
                    >
                        <i v-if="report.is_locked" class="fas fa-lock shadow-text-none font-size-22"></i>
                        <i v-else class="fas fa-lock-open shadow-text-none font-size-22"></i>
                    </div>
                    <div v-else>
                        <i class="fas fa-sync-alt fa-spin shadow-text-none font-size-22 mr-2 opacity-50"></i>
                    </div>
                    <!-- End toggle lock -->
                    <div>
                        <p
                            v-if="
                                report.quiz[0] &&
                                report.quiz[0].share_setting &&
                                report.quiz[0].share_setting.can_access_report
                            "
                        >
                            <span class="font-size-14 shadow-text-none inline-block mt-1">
                                <div class="flex items-center">
                                    <span>
                                        {{
                                            report.is_shared_as_public
                                                ? $t('report_sharing_public')
                                                : $t('report_sharing_private')
                                        }}
                                    </span>
                                    <span
                                        v-tippy="{ placement: 'top' }"
                                        :content="
                                            $t(
                                                !report.is_shared_as_public
                                                    ? 'report_sharing_public_disabled_info'
                                                    : report.is_locked
                                                    ? 'report_sharing_open_locked_info'
                                                    : 'report_sharing_open_unlocked_info'
                                            )
                                        "
                                        class="fas fa-info-circle inline-block ml-2 text-shadow-none cursor-pointer"
                                    ></span>
                                </div>
                            </span>
                        </p>
                        <p v-else class="font-size-14">
                            <span>
                                {{ $t('report_sharing_private') }}
                            </span>
                            <span
                                v-tippy="{ placement: 'top' }"
                                :content="
                                    $t(
                                        report.playing_type == 'live'
                                            ? 'report_sharing_live_is_private'
                                            : 'report_sharing_public_disabled_info'
                                    )
                                "
                                class="fas fa-info-circle inline-block ml-2 text-shadow-none cursor-pointer"
                            ></span>
                        </p>
                    </div>
                </div>
                <div
                    v-else
                    class="flex md:flex-col justify-start lg:justify-center items-start lg:items-center w-full md:w-1/2 lg:w-full"
                >
                    <div
                        v-if="report.quiz[0] && report.quiz[0].user && report.playing_type != 'live'"
                        class="flex md:flex-col items-end lg:items-center justify-center"
                    >
                        <div class="text-xs text-center">
                            <span class="text-xl lg:text-xs mr-2">
                                <i class="fas fa-user-edit"></i>
                            </span>
                            <span class="hidden md:inline">{{ $t('report_thumbnail_quiz_owner') }}</span>
                        </div>
                        <span class="text-sm block text-center">{{ report.quiz[0].user.name }}</span>
                    </div>
                </div>

                <div
                    class="report-button-box flex justify-start lg:justify-end items-center w-full lg:w-1/2 mt-2 md:mt-0 justif-content-box"
                >
                    <div class="report-download-box">
                        <XButton
                            v-tippy="{ placement: 'top' }"
                            @click="openReportSetting(report)"
                            :content="$t('report_view_quiz_result')"
                            class="w-full py-2 shadow-text-none no-underline report-dropdown"
                            aria-label="Download Report"
                            href="#"
                        >
                            <i class="fas fa-poll shadow-text-none font-size-26 report-dropdown"></i>
                        </XButton>
                    </div>
                    <div class="report-download-box">
                        <XButton
                            v-tippy="{ placement: 'top' }"
                            @click="screenWidth >= 1024 ? onDropdown(index, report) : openDownload(report, 'file')"
                            :content="$t('report_download_report')"
                            :disabled="report.is_downloading_report"
                            class="w-full py-2 shadow-text-none no-underline report-dropdown"
                            aria-label="Download Report"
                            href="#"
                        >
                            <i
                                v-if="report.is_downloading_report"
                                class="fas fa-sync-alt fa-spin shadow-text-none font-size-22 mx-3 opacity-50"
                            ></i>
                            <i v-else class="fas fa-download shadow-text-none font-size-24 report-dropdown"></i>
                        </XButton>
                        <div :id="`report-dropdown-${index}`" class="report-dropdown-box hidden">
                            <div class="arrow-up"></div>
                            <div class="dropdown-option p-2 first" @click="onDownloadPDF(report)">
                                <i class="fas fa-file-pdf mr-2"></i>
                                <span class="uppercase">pdf</span>
                            </div>
                            <div class="line mx-1"></div>
                            <div
                                @click="!isOnClick ? onDownloadXlsx(report, report.result_data.type) : ''"
                                :id="`report-dropdown-xlsx-${index}`"
                                class="dropdown-option p-2 second"
                            >
                                <i class="fas fa-file-excel mr-2"></i>
                                <span class="uppercase">xlsx</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="!isWebView" class="report-download-drive-box">
                        <XButton
                            v-tippy="{ placement: 'top' }"
                            @click="
                                screenWidth >= 1024 ? uploadGoogleDrive(index, report) : openDownload(report, 'google')
                            "
                            :content="$t('report_save_to_google_drive')"
                            :disabled="report.is_driving_report"
                            class="w-full py-2 shadow-text-none no-underline flex-col report-dropdown-drive"
                            aria-label="Download to Google Drive"
                            href="#"
                        >
                            <i
                                v-if="report.is_driving_report"
                                class="fas fa-sync-alt fa-spin shadow-text-none font-size-22 mx-3"
                            ></i>
                            <template v-else>
                                <i
                                    :id="`savetodrive-${report._id.$oid}-icon`"
                                    class="fab fa-google-drive shadow-text-none font-size-26 report-dropdown-drive"
                                ></i>
                                <span :id="`savetodrive-${report._id.$oid}`"></span>
                            </template>
                        </XButton>
                        <div :id="`report-dropdown-drive-${index}`" class="report-dropdown-drive-box hidden">
                            <div class="arrow-up"></div>
                            <div
                                @click="
                                    report.playing_type && report.playing_type != 'live'
                                        ? onDownloadPDF(report, true)
                                        : saveToGoogleDrive(report, 'pdf')
                                "
                                class="dropdown-option p-2 first"
                            >
                                <i class="fas fa-file-pdf mr-2"></i>
                                <span class="uppercase">pdf</span>
                            </div>
                            <div class="line mx-1"></div>
                            <div
                                @click="
                                    report.playing_type && report.playing_type != 'live'
                                        ? onDownloadXlsx(report, report.playing_type == 'live' ? 'live' : 'quiz', true)
                                        : saveToGoogleDrive(report, 'xlsx')
                                "
                                :id="`report-dropdown-drive-xlsx-${index}`"
                                class="dropdown-option p-2 second"
                            >
                                <i class="fas fa-file-excel mr-2"></i>
                                <span class="uppercase">xlsx</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ReportDownloadModal
                    v-if="showReportDownloadModal && reportId == report._id.$oid"
                    @close="showReportDownloadModal = false"
                    @google-drive-report-pdf="onGoogleDriveReportPdf"
                    @google-drive-report-xlsx="onGoogleDriveReportXlsx"
                    @download-report-pdf="({ report }) => onDownloadPDF(report)"
                    @download-report-xlsx="({ report, type }) => onDownloadXlsx(report, type)"
                    :report="report"
                    :type-report="typeReport"
                    :id="`report-download-${index}`"
                />
            </div>
            <div v-if="$route.name !== 'report'" class="flex items-center justify-center col-12 my-3">
                <Paginator
                    v-if="showPaginator && totalItems > 0"
                    @pagination-change="onPageChange"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    :total-items="totalItems"
                />
            </div>
        </div>
        <MergeReportSetting
            v-if="isOpenMergeReportSetting"
            @close="onCloseMergeReportSetting"
            @result="currentReportSetting = $event"
            :modal-title="$t('report_thumbnail_display_setting_modal_title')"
            :setting="currentReportSetting"
            :validate-on-close="false"
            :loading="isSubmitLoading"
            :mode="isDownload && isDownload.report ? 'report' : 'leaderboard'"
            ref="mergeReportSetting"
        >
            <template #footer>
                <div class="flex justify-end items-center">
                    <XButton
                        @click.prevent="onSubmitReportSetting"
                        :disabled="isSubmitLoading"
                        class="system-button-color system-button-text-color w-full"
                    >
                        <i v-if="isSubmitLoading" class="fas fa-spinner fa-spin"></i>
                        <template v-if="isDownload && isDownload.report">
                            {{ $t('report_thumbnail_display_setting_modal_download') }}
                        </template>
                        <template v-else>
                            {{
                                currentReportSetting.status
                                    ? $t('merge_report_submit_button')
                                    : $t('merge_report_update_setting_button')
                            }}
                        </template>
                    </XButton>
                </div>
            </template>
        </MergeReportSetting>
    </div>
</template>

<script>
import Request from '@/lib/request'
import UserService from '@/lib/user'
import appConfig from '@/app.config'
import XButton from '@/components/v2/XButton'
import ReportDownloadModal from '@/components/ReportDownloadModal'
import popup from '@/lib/popup.js'
import XSelect from '@/components/v2/XSubjectSelect.vue'
import Paginator from '@/components/Paginator'
import Url from '@/lib/url'
import helper from '@/lib/helper.js'
import UpgradeReportAlert from '@/components/UpgradeReportAlert'
import { mapGetters } from 'vuex'
import MergeReportSetting from '@/components/merge-report/MergeReportSetting'
import introJsData from '@/mixins/introjs-data'
import { startIntroReports } from '@/lib/intro.js'

export default {
    components: {
        XButton,
        ReportDownloadModal,
        XSelect,
        Paginator,
        UpgradeReportAlert,
        MergeReportSetting
    },

    mixins: [introJsData],

    props: {
        page: {
            type: String,
            default: null
        }
    },

    computed: {
        isDesktop() {
            return helper.desktop()
        },

        isWebView() {
            return helper.webView()
        },

        ...mapGetters({
            orderAbility: 'orderAbility'
        })
    },

    watch: {
        $route() {
            const url = new Url()

            this.getReportByUser(url.buildQuery())
        },

        orderAbility: {
            handler(value) {
                if (!value) return

                if (value.is_24hrs_access || value.is_has_subscribed) {
                    this.showUpgradeAlert = false
                }
            },

            deep: true
        }
    },

    data() {
        return {
            quizReportLists: [],
            isQuizListLoaded: false,
            showReportDetailModal: false,
            showReportDownloadModal: false,
            currentReportDetail: {
                players: []
            },
            quizLists: [],
            currentPage: 1,
            pageCount: 0,
            totalItems: 0,
            preventPageChange: false,
            indexReport: null,
            indexReportDrive: null,
            reportId: null,
            screenWidth: 0,
            typeReport: 'file',
            isOnClick: false,
            showUpgradeAlert: false,
            isOpenMergeReportSetting: false,
            isSubmitLoading: false,
            currentReportSetting: {
                displayRanking: 10,
                reloadTime: 2,
                layout: 'list',
                status: true,
                mergePlayerOption: 'same_name_device_id',
                showRankingTime: 10,
                displayMultipleResponseWith: 'best'
            },
            filterType: 'all',
            showPaginator: true,
            isDownload: {
                report: null,
                filetype: null, // pdf, xlsx or null
                type: null, // quiz or live,
                saveToDrive: false
            }
        }
    },

    mounted() {
        this.screenWidth = screen.width
        this.getQuizByUser()
        if (this.screenWidth > 768) {
            document.addEventListener('click', function (e) {
                if (!e.target.classList.contains('report-dropdown')) {
                    let collection = document.getElementsByClassName('report-dropdown-box')
                    let index = 0

                    for (let i in collection) {
                        if (i != 'length' && i != 'item' && i != 'namedItem') {
                            document.getElementById(`report-dropdown-${index}`).classList.add('hidden')
                            index++
                        }
                    }
                }
            })

            document.addEventListener('click', function (e) {
                if (!e.target.classList.contains('report-dropdown-drive')) {
                    let index1 = 0
                    let collectionDrive = document.getElementsByClassName('report-download-drive-box')

                    for (let ii in collectionDrive) {
                        if (ii != 'length' && ii != 'item' && ii != 'namedItem') {
                            document.getElementById(`report-dropdown-drive-${index1}`).classList.add('hidden')
                            index1++
                        }
                    }
                }
            })
        }

        //show intro reports
        setTimeout(() => {
            startIntroReports(this.stepTour12)
        }, 700)
    },

    created() {
        var url = new Url()

        if (this.page == 'my-quiz') {
            this.getReportByUser(url.buildQuery())
        } else {
            this.getReportByQuiz()
        }
    },

    methods: {
        onPageChange(page) {
            this.currentPage = page

            const urlParams = new URL(window.location.href)

            urlParams.searchParams.set('page', this.currentPage)
            window.history.replaceState(null, null, urlParams.toString())

            this.getReportByUser(urlParams.searchParams)

            document.getElementById('app').scrollTo(0, 0)
        },

        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        onFilterWithType(type) {
            const urlParams = new URL(window.location.href)
            this.filterType = type

            this.currentPage = 1
            this.pageCount = 0
            this.totalItems = 0

            urlParams.searchParams.set('page', this.currentPage)
            urlParams.searchParams.set('filter_type', type)

            window.history.replaceState(null, null, urlParams.toString())

            this.showPaginator = false
            this.getReportByUser(urlParams.searchParams)

            document.getElementById('app').scrollTo(0, 0)
        },

        getReportByUser(params) {
            const roles = ['super_admin', 'admin', 'premium_user', 'teacher_plus', 'student_plus']
            if (
                !roles.includes(this.orderAbility.role) &&
                !this.orderAbility.is_24hrs_access &&
                !this.orderAbility.is_has_subscribed
            ) {
                this.showUpgradeAlert = true
            }

            const request = this.createRequest()
            const url = appConfig.api.getReportAllByUser

            this.$store.commit('toggleMainLoader', true)

            request
                .get(url, { params })
                .then(res => {
                    this.$store.commit('toggleMainLoader', false)

                    this.quizReportLists = res.data.data.data.map(report => {
                        report.is_updating_report = false
                        report.is_downloading_report = false
                        report.is_driving_report = false

                        return report
                    })
                    this.pageCount = parseInt(res.data.data.page_count)
                    this.currentPage = parseInt(res.data.data.current_page)
                    this.totalItems = parseInt(res.data.data.total)

                    this.showPaginator = true

                    this.$emit('count-report', this.totalItems)
                })
                .catch(err => {
                    this.$store.commit('toggleMainLoader', false)

                    if (err.response.status === 403) {
                        return popup.alert('You dont have permission to access this quiz', () => {
                            window.location.href = '/'
                        })
                    }
                })
                .finally(() => {
                    this.isQuizListLoaded = true
                })
        },

        onDownloadPDF(report, saveToDrive = false) {
            if (report.playing_type == 'live') {
                return this.downloadReport(report, saveToDrive)
            }

            this.isDownload = {
                report,
                filetype: 'pdf',
                saveToDrive
            }

            this.openReportSetting(report)
        },

        onDownloadXlsx(report, type, saveToDrive = false) {
            if (report.playing_type == 'live') {
                return this.downloadReportXlsx(report, type, saveToDrive)
            }

            this.isDownload = {
                report,
                filetype: 'xlsx',
                type,
                saveToDrive
            }

            this.openReportSetting(report)
        },

        downloadReport(report, saveToDrive) {
            const baseUrl = process.env.VUE_APP_ROOT_URL

            if (report.pdf_path && report.playing_type == 'live') {
                this.showReportDownloadModal = false

                window.open(`${baseUrl}${report.pdf_path}`, '_blank')

                report.is_downloading_report = true

                return
            }

            if (saveToDrive) {
                report.is_driving_report = true
            } else {
                report.is_downloading_report = true
            }

            const request = this.createRequest()

            request
                .post(appConfig.api.playAloneReport, {
                    report_id: report._id.$oid
                })
                .then(res => {
                    const path = res.data.data.path.slice(1)
                    report.pdf_path = path

                    if (saveToDrive) {
                        return this.saveToGoogleDrive(report, 'pdf')
                    }

                    window.open(`${baseUrl}${path}`, '_blank')
                })
                .finally(() => {
                    this.showReportDownloadModal = false
                    report.is_downloading_report = false
                })
        },

        downloadReportXlsx(report, type = 'quiz', saveToDrive) {
            const baseUrl = process.env.VUE_APP_ROOT_URL

            if (saveToDrive) {
                report.is_driving_report = true
            } else {
                report.is_downloading_report = true
            }

            if (report.xlsx_path && report.playing_type == 'live') {
                this.showReportDownloadModal = false

                window.open(`${baseUrl}${report.xlsx_path}`, '_blank')

                report.is_downloading_report = false

                return
            }

            const request = this.createRequest()

            request
                .post(appConfig.api.playAloneReportXlsx, {
                    report_id: report._id.$oid
                })
                .then(res => {
                    const path = res.data.data.path.slice(1)
                    report.xlsx_path = path

                    if (saveToDrive) {
                        return this.saveToGoogleDrive(report, 'xlsx')
                    }

                    window.open(`${baseUrl}${path}`, '_blank')

                    report.is_downloading_report = false
                })
                .finally(() => {
                    this.showReportDownloadModal = false
                    report.is_driving_report = false
                    report.is_downloading_report = false
                })
        },

        saveToGoogleDrive(report, type = 'pdf') {
            report.is_driving_report = true

            let file = type == 'pdf' ? report.pdf_path : report.xlsx_path

            file = file.replace(/\/?uploads/, '')

            let filename = file.split('/').pop()
            let fileType = filename.split('.')

            fileType = fileType[fileType.length - 1]

            if (report.name) {
                report.name = report.name.replace(/\s/g, '-')
                filename = `${report.name}-${filename}`
            }

            const screenWidth = window.screen.width
            const screenHeight = window.screen.height

            const left = screenWidth / 2 - 650 / 2
            const top = screenHeight / 2 - 700 / 2

            const popup = window.open(
                `${process.env.VUE_APP_DRIVE_API_BASE_URL}/auth?file=${file}&name=${filename}&type=${fileType}`,
                'Google OAuth',
                `scrollbars=no, resizable=no, status=no, location=no, toolbar=no,menubar=no, width=650, height=700, left=${left}, top=${top}`
            )

            const messageEvent = event => {
                const message = event.data.message

                if (typeof message === 'undefined') return

                if (message === 'success') {
                    this.toastSuccess(this.$t('report_save_to_google_drive_success'))
                } else {
                    this.toastError(this.$t('report_save_to_google_drive_failed'))
                }

                popup.close()

                window.removeEventListener('message', messageEvent)
            }

            const interval = setInterval(() => {
                if (popup.closed) {
                    clearInterval(interval)

                    report.is_driving_report = false
                    this.showReportDownloadModal = false

                    window.removeEventListener('message', messageEvent)
                }
            }, 800)

            window.addEventListener('message', messageEvent)
        },

        listPlayerInReport(report) {
            const reportId = report._id.$oid
            const request = this.createRequest()

            request
                .get(appConfig.api.listPlayerInReport.replace(/__id__/, reportId))
                .then(res => {
                    this.showReportDetailModal = true
                    this.currentReportDetail = {
                        players: res.data.data
                    }
                })
                .catch(() => {})
        },

        onInput(val) {
            var url = new Url()
            this.$store.commit('toggleMainLoader', true)

            if (!val.target.value) {
                this.filterType = 'all'
            }

            this.$router.push({
                name: this.$router.currentRoute.name,
                query: url.buildQuery({
                    page: 1,
                    id: val.target.value ? val.target.value.id : ''
                })
            })
        },

        getQuizByUser() {
            const request = this.createRequest()
            const url = appConfig.api.getQuizByUser

            this.$store.commit('toggleMainLoader', true)

            request
                .get(url)
                .then(res => {
                    this.$store.commit('toggleMainLoader', false)
                    this.quizLists = res.data.data.map(report => {
                        report.title = report.title.replace(/report_shared_with_me/, this.$t('report_shared_with_me'))

                        return report
                    })

                    this.$store.commit('setQuizByUser', this.quizLists)
                })
                .catch(err => {
                    this.$store.commit('toggleMainLoader', false)

                    if (err.response.status === 403) {
                        return popup.alert('You dont have permission to access this quiz', () => {
                            window.location.href = '/'
                        })
                    }
                })
        },

        setTitleQuiz(item) {
            for (let index in item) {
                return item[index].title
            }
        },

        getReportByQuiz() {
            const roles = ['super_admin', 'admin', 'premium_user', 'teacher_plus', 'student_plus']
            if (
                !roles.includes(this.orderAbility.role) &&
                !this.orderAbility.is_24hrs_access &&
                !this.orderAbility.is_has_subscribed
            ) {
                this.showUpgradeAlert = true
            }

            const request = this.createRequest()
            const quizId = this.$route.params.quizId
            const url = appConfig.api.getReportByUser.replace(/__id__/, quizId)

            request
                .get(url, { params: { timezone: helper.getTimeZone() } })
                .then(res => {
                    this.quizReportLists = res.data.data.reports.map(report => {
                        report.is_updating_report = false
                        report.is_downloading_report = false
                        report.is_driving_report = false

                        return report
                    })

                    this.$emit('count-report', this.quizReportLists.length)
                    this.$emit('receive-report-data', res.data.data)
                })
                .catch(err => {
                    if (err.response.status === 403) {
                        return popup.alert('You dont have permission to access this quiz', () => {
                            window.location.href = '/'
                        })
                    }
                })
        },

        onDropdown(id, report) {
            this.isOnClick = false
            if (this.indexReport == id) {
                if (report.playing_type == 'live' && typeof report.xlsx_path == 'undefined') {
                    this.isOnClick = true
                }

                if (document.getElementById(`report-dropdown-${id}`).classList.contains('hidden')) {
                    document.getElementById(`report-dropdown-${id}`).classList.remove('hidden')
                } else {
                    document.getElementById(`report-dropdown-${id}`).classList.add('hidden')
                }
            } else {
                this.checkReportDropdownBox()

                if (report.playing_type == 'live' && typeof report.xlsx_path == 'undefined') {
                    document.getElementById(`report-dropdown-xlsx-${id}`).classList.add('report-dropdown-xlsx')
                    this.isOnClick = true
                }

                if (document.getElementById(`report-dropdown-${id}`).classList.contains('hidden')) {
                    document.getElementById(`report-dropdown-${id}`).classList.remove('hidden')
                } else {
                    document.getElementById(`report-dropdown-${id}`).classList.add('hidden')
                }
            }
            this.indexReport = id
        },

        checkReportDropdownBox() {
            let collection = document.getElementsByClassName('report-dropdown-box')
            let index = 0

            for (let i in collection) {
                if (i != 'length' && i != 'item' && i != 'namedItem') {
                    document.getElementById(`report-dropdown-${index}`).classList.add('hidden')
                    index++
                }
            }
        },

        openDownload(report, type) {
            this.showReportDownloadModal = true
            this.reportId = report._id.$oid
            this.typeReport = type
        },

        uploadGoogleDrive(id, report) {
            if (this.indexReportDrive == id) {
                if (document.getElementById(`report-dropdown-drive-${id}`).classList.contains('hidden')) {
                    document.getElementById(`report-dropdown-drive-${id}`).classList.remove('hidden')
                } else {
                    document.getElementById(`report-dropdown-drive-${id}`).classList.add('hidden')
                }
            } else {
                this.checkReportDropdownGoogleDrive()

                if (report.playing_type == 'live' && typeof report.xlsx_path == 'undefined') {
                    document.getElementById(`report-dropdown-drive-xlsx-${id}`).classList.add('report-dropdown-xlsx')
                }

                if (document.getElementById(`report-dropdown-drive-${id}`).classList.contains('hidden')) {
                    document.getElementById(`report-dropdown-drive-${id}`).classList.remove('hidden')
                } else {
                    document.getElementById(`report-dropdown-drive-${id}`).classList.add('hidden')
                }
            }
            this.indexReportDrive = id
        },

        checkReportDropdownGoogleDrive() {
            let collection = document.getElementsByClassName('report-dropdown-drive-box')
            let index = 0

            for (let i in collection) {
                if (i != 'length' && i != 'item' && i != 'namedItem') {
                    document.getElementById(`report-dropdown-drive-${index}`).classList.add('hidden')
                    index++
                }
            }
        },

        onGoogleDriveReportPdf(val) {
            if (val.playingType == 'playalone') {
                this.downloadReport(val.report, true)
            } else {
                this.saveToGoogleDrive(val.report, val.type)
            }
        },

        onGoogleDriveReportXlsx(val) {
            if (val.playingType == 'playalone') {
                this.downloadReportXlsx(val.report, 'quiz', true)
            } else {
                this.saveToGoogleDrive(val.report, val.type)
            }
        },

        openMergeReportModal() {
            if (!this.orderAbility.has_subscribed) {
                this.$store.commit('openPaymentPopup', true)
                return
            }

            this.$store.commit('setMergeReportModal', true)
        },

        async onUpdateLockReport(report) {
            const request = this.createRequest()
            const url = appConfig.api.updateLockStatus.replace(/__id__/, report._id.$oid)

            report.is_updating_report = true

            try {
                await request.post(url, {
                    is_locked: !report.is_locked
                })

                report.is_locked = !report.is_locked
                report.is_updating_report = false

                this.toastSuccess(this.$t('report_sharing_update_status_succes'))
            } catch {
                this.toastError(this.$t('report_sharing_update_status_fail'))
            }
        },

        openReportSetting(report) {
            this.isOpenMergeReportSetting = true

            this.currentReportSetting = {
                displayRanking: report.ranking_setting.display_ranking,
                reloadTime: report.ranking_setting.time_to_reload,
                layout: report.ranking_setting.layout,
                status: report.ranking_setting.status,
                mergePlayerOption: report.ranking_setting.merge_player_option,
                showRankingTime: report.ranking_setting.show_ranking_time,
                displayMultipleResponseWith: report.ranking_setting.display_multiple_response_with,
                id: report._id.$oid
            }
        },

        async onSubmitReportSetting() {
            const validateResult = await this.$refs.mergeReportSetting.validate()

            if (!validateResult) return

            this.isSubmitLoading = true

            const request = this.createRequest()
            const url = appConfig.api.updateReportRanking.replace(/__id__/, this.currentReportSetting.id)

            const payload = {
                display_ranking: this.currentReportSetting.displayRanking,
                time_to_reload: this.currentReportSetting.reloadTime,
                layout: this.currentReportSetting.layout,
                status: this.currentReportSetting.status,
                merge_player_option: this.currentReportSetting.mergePlayerOption,
                show_ranking_time: this.currentReportSetting.showRankingTime,
                display_multiple_response_with: this.currentReportSetting.displayMultipleResponseWith
            }

            try {
                const res = await request.post(url, payload)
                const index = this.quizReportLists.findIndex(item => item._id.$oid === this.currentReportSetting.id)
                this.quizReportLists[index].ranking_setting = res.data.data.setting

                if (this.isDownload.filetype === 'pdf') {
                    this.downloadReport(this.isDownload.report, this.isDownload.saveToDrive)
                }

                if (this.isDownload.filetype === 'xlsx') {
                    this.downloadReportXlsx(this.isDownload.report, this.isDownload.type, this.isDownload.saveToDrive)
                }

                if (res.data.data.setting.status && !this.isDownload.filetype) {
                    window.open(this.quizReportLists[index].report_result_url, '_blank')
                }

                this.toastSuccess(this.$t('report_ranking_update_status_success'))
            } catch (e) {
                this.toastError(this.$t('report_ranking_update_status_fail'))
            } finally {
                this.isOpenMergeReportSetting = false
                this.isSubmitLoading = false

                this.resetReportDownload()
            }
        },

        onCloseMergeReportSetting() {
            this.isOpenMergeReportSetting = false
            this.resetReportDownload()
        },

        resetReportDownload() {
            // Reset download data
            this.isDownload = {
                report: null,
                filetype: null,
                type: null,
                saveToDrive: false
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/mixin.scss';

.report-thumbnail {
    .report-row {
        border-radius: 4px;
    }

    .empty-container {
        border: 2px solid var(--ui-primary-color-alpha-50);
        border-radius: 6px;
    }

    .select-quiz-thumbnail {
        align-items: center;
        position: relative;
        display: inherit;
        max-width: 40%;
        margin: auto;
        margin-bottom: 30px;

        #report-select-quiz {
            & .vs__no-options {
                font-size: 16px;
            }
        }
    }

    .report-button-box {
        column-gap: 1rem;
        margin-top: 1rem;

        @media screen and (min-width: 1024px) {
            margin-top: 0;
        }

        .report-download-box {
            flex: 1;
            position: relative;

            @media screen and (min-width: 1024px) {
                flex: unset;
            }

            .x-button {
                background-color: transparent !important;
                color: #333333 !important;
                max-width: 40px;

                @media screen and (max-width: 1023px) {
                    max-width: unset;
                    background-color: #000000 !important;
                    color: #ffffff !important;
                }
            }

            .report-dropdown-box {
                top: 50px;
                left: 0;
                position: absolute;
                min-width: 100px;
                height: auto;
                background-color: #000000;
                color: #ffffff !important;
                border: 1px solid #ffffff;
                border-radius: 0.25rem;
                z-index: 2;
                cursor: pointer;
                .arrow-up {
                    position: absolute;
                    top: -8px;
                    left: 22px;
                    width: 0;
                    height: 0;
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                    border-bottom: 8px solid #000000;
                }

                .dropdown-option {
                    position: relative;

                    &.first {
                        border-top-left-radius: 0.25rem;
                        border-top-right-radius: 0.25rem;
                    }

                    &.second {
                        border-bottom-left-radius: 0.25rem;
                        border-bottom-right-radius: 0.25rem;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 90%;
                        height: 100%;
                        // border-bottom: 1px solid;
                    }

                    &:hover {
                        background-color: #333333;
                    }
                }

                .line {
                    border: 0;
                    background-color: #ffffff;
                    height: 1px;
                }
            }
        }

        .report-download-drive-box {
            flex: 1;
            position: relative;

            @media screen and (min-width: 1024px) {
                flex: unset;
            }

            .x-button {
                background-color: transparent !important;
                color: #333333 !important;
                max-width: 40px;

                @media screen and (max-width: 1023px) {
                    max-width: unset;
                    background-color: #000000 !important;
                    color: #ffffff !important;
                }
            }

            .report-dropdown-drive-box {
                top: 50px;
                right: 50%;
                transform: translateX(50%);
                position: absolute;
                min-width: 100px;
                height: auto;
                background-color: #000000;
                color: #ffffff !important;
                border: 1px solid #ffffff;
                border-radius: 0.25rem;
                z-index: 2;
                cursor: pointer;
                .arrow-up {
                    position: absolute;
                    top: -8px;
                    left: 50%;
                    transform: translate(-50%);
                    width: 0;
                    height: 0;
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                    border-bottom: 8px solid #000000;
                }

                .dropdown-option {
                    position: relative;

                    &.first {
                        border-top-left-radius: 0.25rem;
                        border-top-right-radius: 0.25rem;
                    }

                    &.second {
                        border-bottom-left-radius: 0.25rem;
                        border-bottom-right-radius: 0.25rem;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 90%;
                        height: 100%;
                        // border-bottom: 1px solid;
                    }

                    &:hover {
                        background-color: #333333;
                    }
                }

                .line {
                    border: 0;
                    background-color: #ffffff;
                    height: 1px;
                }
            }
        }
    }

    .report-dropdown-xlsx {
        opacity: 0.5;
        cursor: no-drop;
    }

    .report-dropdown-drive-xlsx {
        opacity: 0.5;
        cursor: no-drop;
    }

    .report-download-modal {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #ffffff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;

        @media screen and (min-width: 1024px) {
            flex-direction: row;
        }
    }

    .report-download-w100 {
        width: 80%;
        display: initial;
        margin: 0;
        text-align: center;
    }

    .vs__selected {
        margin: 0 !important;
    }

    @media screen and (max-width: 768px) {
        .select-quiz-thumbnail {
            max-width: 60%;
        }

        .justif-content-box {
            justify-content: center;
        }
    }
    @media screen and (max-width: 425px) {
        .select-quiz-thumbnail {
            max-width: 100%;
        }
    }

    .report-name-container {
        width: 200px;

        @media screen and (max-width: 992px) {
            width: 100%;
        }
    }
}
</style>
